import { computed, Ref, ref } from 'vue';
import { IMultiSelect } from '@studyportals/multiselect/src/interfaces/multiselect.interface';
import { IOption } from '@studyportals/multiselect/src/interfaces/options.interface';
import { ClientFiltersAppliedEvent } from '@/event-bus/client-filters-applied-event';
import tableSelectorRetriever from '@/presentation/components/generalizations/table-selectors/table-selector-retriever';
import EventBus from '@/event-bus/event-bus';
import store from '@/store';

export default class OptionalFilterSectionSourceComponent {
	public sourceDropdown: Ref<IMultiSelect | null> = ref(null);
	private sourceFilter = tableSelectorRetriever.retrieveSourceFilter();
	private eventSubscriptionToken = ref('');

	public sourceOptions = computed((): IOption[] => {
		return this.sourceFilter.options.value.filter((option) => !option.isDefaultOption);
	});

	public mounted(): void {
		this.eventSubscriptionToken.value = EventBus.getEvent(ClientFiltersAppliedEvent).subscribe(this.selectSource.bind(this));
		this.prefillValue();
	}

	public unmounted(): void {
		EventBus.getEvent(ClientFiltersAppliedEvent).unsubscribe(this.eventSubscriptionToken.value);
	}

	public selectSource(): void {
		if (!this.sourceDropdown.value?.selectedOption?.value) {
			return;
		}

		const selectedOption = this.sourceDropdown.value.selectedOption.value as string;
		this.sourceFilter.setSelectedOption(selectedOption);
		this.filterEnrolments();
	}

	private filterEnrolments(): void {
		store.actions.updateFilteredEnrolments();
	}

	private prefillValue(): void {
		if (
			!this.sourceFilter.selectedOptionAsOption.value ||
			!this.sourceDropdown.value ||
			this.sourceFilter.selectedOptionIsDefault.value
		) {
			return;
		}

		this.sourceDropdown.value.selectOption(this.sourceFilter.selectedOptionAsOption.value as IOption);
	}
}
